import * as React from "react";
import styled from "styled-components";
import { BULK_SELECT_COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
const Cell = styled.div`
  width: ${BULK_SELECT_COLUMN_WIDTH}px;
`;
const BulkSelectCell = ({ children = void 0, role = "cell" }) => /* @__PURE__ */ React.createElement(Cell, { role }, children);
export default BulkSelectCell;
